import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  withCombinedStyles,
  withComposedEnhancers
} from '../../../utils/hocUtils';

import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import LoadingOrError from '../../LoadingOrError';

import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import ReportStyles from '../../../pages/reports/Report.styles';

import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  Button,
  Divider
} from '@material-ui/core';
import { formatDate } from '../../../utils/DateTime';

const InvoiceBatchesSummary = ({
  t,
  classes,
  fillHeight,
  lastBatch,
  batchCount,
  loading,
  error
}) => {
  const cardStyle = {};
  if (fillHeight) cardStyle.height = '100%';

  return (
    <Card square style={cardStyle}>
      <CardHeader
        title={t('Invoice Batches')}
        action={
          <Button
            component={Link}
            to="/reports/carrier-invoice-batches"
            color="primary"
          >
            {t('View')}
          </Button>
        }
        classes={{ title: classes.headline6 }}
      />
      <Divider />
      <CardContent>
        {!loading && !error && (
          <Fragment>
            <Grid container spacing={24}>
              <Grid item xs={6}>
                <Typography
                  component="div"
                  className={classes.cardStat}
                  gutterBottom
                >
                  {batchCount.totalBatches}
                </Typography>
                <Typography className={classes.cardLabel}>
                  {t('Batches Processed')}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  component="div"
                  className={classes.cardStat}
                  gutterBottom
                >
                  {batchCount.totalInvoices}
                </Typography>
                <Typography className={classes.cardLabel}>
                  {t('Invoices Processed')}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={24}>
              <Grid item xs={6}>
                <Typography
                  component="div"
                  className={classes.cardStat}
                  gutterBottom
                >
                  ${lastBatch.totalAmountDue}
                </Typography>
                <Typography className={classes.cardLabel}>
                  {t('Last Batch Total')}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  component="div"
                  className={classes.cardStat}
                  gutterBottom
                >
                  {formatDate(lastBatch.createdUtc)}
                </Typography>
                <Typography className={classes.cardLabel}>
                  {t('Last Batch Date')}
                </Typography>
              </Grid>
            </Grid>
          </Fragment>
        )}
        <LoadingOrError
          loading={loading}
          error={error}
          classes={{ root: classes.loadingOrError }}
        />
      </CardContent>
    </Card>
  );
};

InvoiceBatchesSummary.propTypes = {
  lastBatch: PropTypes.object,
  batchCount: PropTypes.object
};

export default withComposedEnhancers(
  InvoiceBatchesSummary,
  withNamespaces(),
  withCombinedStyles(true, TypographyStyles, LayoutStyles, ReportStyles)
);
